import { SidebarMenuItem } from "@kaltura/mediaspace-shared-types";

export const isLabelMenuItem = (item: SidebarMenuItem) => !item.uri && !item.pages?.length;
